"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _ChatMessageSimple = require("./ChatMessageSimple");
Object.keys(_ChatMessageSimple).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ChatMessageSimple[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _ChatMessageSimple[key];
    }
  });
});